import React from "react";
import { useDispatch, useSelector } from "react-redux";
import numeral from "numeral";
import { RadioGroup } from "@headlessui/react";
import qrCode from "../../../../assets/images/icons/qr-code.jpg";
import AppStore from "../../../../assets/images/checkout/AppleStore.svg";
import PlayStore from "../../../../assets/images/checkout/PlayStore.svg";

const SubscriptionCard = () => {
  return (
    <div className="card sub-card">
      <div className="sub-card__badge-container">
        <div className="sub-card__badge"></div>
      </div>
      <div className="sub-card__text-container">
        <div className="sub-card__header">inKind Pass</div>
        <div className="sub-card__under">Subscription</div>
      </div>
    </div>
  );
};

export default SubscriptionCard;
